import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScUiTabsComponent } from './scui-tabs.component';

@NgModule({
  declarations: [ScUiTabsComponent],
  imports: [
    CommonModule,
  ],
  exports: [ScUiTabsComponent]
})
export class ScUiTabsModule {
}
